if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }

      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');

      if (!cartLink) {
        return;
      }

      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');

      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });

      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (typeof window.cartDrawerUpdate === 'function') {
        window.cartDrawerUpdate();
      }

      if (triggeredBy) {
        this.setActiveElement(triggeredBy);
      }

      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');

      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
        this.setSummaryAccessibility(cartDrawerNote);
      }

      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');

          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

          if (containerToTrapFocusOn && focusElement && typeof trapFocus === 'function') {
            trapFocus(containerToTrapFocusOn, focusElement);
          }
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.activeElement);
      }

      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget.closest('details').hasAttribute('open')
        );
      });

      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
      this.classList.remove('is-empty');

      const drawerInner = this.querySelector('.drawer__inner');

      if (drawerInner && drawerInner.classList.contains('is-empty')) {
        drawerInner.classList.remove('is-empty');
      }

      this.productId = parsedState.id;

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) {
          return;
        }

        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });

      setTimeout(() => {
        const overlay = this.querySelector('#CartDrawer-Overlay');

        if (overlay) {
          overlay.addEventListener('click', this.close.bind(this));
        }

        this.open();
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const element = parsedHTML.querySelector(selector);

      return element ? element.innerHTML : '';
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('cart-drawer-items') && typeof CartItems !== 'undefined') {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
}
/* Dice Dungeons cart drawer add-ons */

(function () {
  function ddGetCartAddUrl() {
    if (window.routes && window.routes.cart_add_url) {
      return window.routes.cart_add_url;
    }

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return `${window.Shopify.routes.root}cart/add.js`;
    }

    return '/cart/add.js';
  }

  function ddGetCartSections(cartDrawer) {
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map((section) => section.id);
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function ddShowAddonError(message) {
    const errors = document.getElementById('CartDrawer-CartErrors');

    if (errors) {
      errors.textContent = message || 'There was an error adding this item. Please try again.';
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-dd-cart-addon-variant]');

    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.dataset.ddAdding === 'true') {
      return;
    }

    const variantId = Number(button.dataset.ddCartAddonVariant);

    if (!variantId) {
      ddShowAddonError('This add-on could not be added. The variant ID is missing.');
      return;
    }

    const cartDrawer = document.querySelector('cart-drawer');
    const originalText = button.textContent;

    button.dataset.ddAdding = 'true';
    button.disabled = true;
    button.textContent = 'Adding';

    fetch(ddGetCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
        sections: ddGetCartSections(cartDrawer),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status || parsedState.errors) {
          throw new Error(parsedState.description || parsedState.message || 'Unable to add this item.');
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(parsedState);
          return;
        }

        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error('Cart add-on failed:', error);
        ddShowAddonError(error.message);

        button.dataset.ddAdding = 'false';
        button.disabled = false;
        button.textContent = originalText;
      });
  });
})();